import { Component } from '@angular/core';
import { NavController, NavParams, Events } from 'ionic-angular';
import { UserData } from '../../../providers/user-data';
import { CartData } from '../../../providers/cart-data';
import { AccountPage } from '../../../modules/account/pages/account/account';
import { CartPage } from '../../../pages/cart/cart';
import _ from 'lodash';

//shop-detail view
@Component({
  selector: 'page-product-details',
  templateUrl: 'product-details.html',
})

export class ProductDetailsPage {
  public product: any;
  public cartItems: any=[];
  public cartTotal: number=0;
  public currentUser: any;
  public isLoading: boolean = true;

  constructor(
      private params: NavParams, 
      private nav: NavController, 
      private cartData: CartData,
      private userData: UserData,
      private events: Events
      ) 
  {
    
  }

  ionViewDidEnter() {
    let self = this;
    self.isLoading = true;
    self.product = self.params.get("product");   
    if(!self.product.value.cartCount){self.product.value.cartCount = 0;}  
    self.userData.hasLoggedIn().subscribe((isLoggedIn) => {
      console.log(isLoggedIn);
      
      if(isLoggedIn){
          self.userData.getUser().subscribe((user) => {
              self.currentUser = user;
              self.cartData.getAllItems(self.currentUser.uid).subscribe(items => {
                    self.cartItems = items;                    
                    self.isLoading = false;
                    self.processCartItems();
              });
              
          });
      }else{
          self.nav.push(AccountPage);
      }
    });
  }

  private processCartItems(){
    let self = this;
    self.cartTotal = 0;
    _.each(self.cartItems, function(item){
      self.cartTotal += item.value.value.cartCount;
      if(self.product.key==item.value.key){
        self.product.value.cartCount = item.value.value.cartCount;
        self.product.value.cartItemId = item.key;
      }
    });
  }

  public updateCart(product, quantity){

    product.value.cartCount += quantity;
    if(product.value.cartCount < 0){
      product.value.cartCount=0;
    }

    var self = this;
    if(self.product.value.cartCount == 0){
      self.cartData.deleteItem(self.currentUser.uid, self.product.value.cartItemId).subscribe(isDeleted=>{
        console.log("Item deleted");
        self.cartItems = _.reject(self.cartItems, function(item:any){
          return (item.key == product.value.cartItemId);
        })
      })
    }else {
      if(!self.product.value.cartItemId){
        self.cartData.addItem(self.currentUser.uid, product).subscribe(newKey =>{
          self.product.value.cartItemId = newKey;
          console.log("Add New Item", newKey);
        });
      }else{
        self.cartData.updateItem(self.currentUser.uid, product).subscribe(updated =>{
          console.log("Update Cart:", updated);
        });
      }
    }
  }

  public loadCart(){
    this.nav.push(CartPage, {cartItems: this.cartItems});
  }
}


// WEBPACK FOOTER //
// ./src/pages/orders/components/product-details.ts